import { ListAssignedContent } from "./pages/listAssignedContent";
import { ViewAssignedContentDetail } from "./pages/viewAssignedContentDetail";
import { ListAllContent } from "./pages/listAllContent";
import { ViewContentDetail } from "./pages/viewContentDetail";

import { buildBreadcrumbNavigationConfig } from "../shared/helpers/buildBreadcrumbNavigationConfig";

const participantAssignedContentPath = "/assignedContent";
const participantWatchedContentPath = "/assignedContent/WatchedContent";
const participantContentDetailsPath = "/assignedContent/:id/details";
const contentPath = "/content";
const contentIdPath = "/content/:id";

const participantAssignedContentPageNav = buildBreadcrumbNavigationConfig(
  "My Content",
  participantAssignedContentPath
);
const participantWatchedContentPageNav = buildBreadcrumbNavigationConfig(
  "Watched Content",
  participantWatchedContentPath
);
const participantContentDetailsPageNav = buildBreadcrumbNavigationConfig(
  "My Content Detail",
  participantContentDetailsPath
);
const contentPageNav = buildBreadcrumbNavigationConfig("Content", contentPath);
const contentIdPageNav = buildBreadcrumbNavigationConfig(
  "Content Detail",
  contentIdPath
);

export const routes = [
  {
    path: participantAssignedContentPath,
    Component: ListAssignedContent,
    navigation: [participantAssignedContentPageNav],
    exact: true,
    isPrivate: true,
  },
  {
    path: participantWatchedContentPath,
    Component: ListAssignedContent,
    navigation: [
      participantAssignedContentPageNav,
      participantWatchedContentPageNav,
    ],
    exact: true,
    isPrivate: true,
  },
  {
    path: participantContentDetailsPath,
    Component: ViewAssignedContentDetail,
    navigation: [
      participantAssignedContentPageNav,
      participantContentDetailsPageNav,
    ],
    exact: true,
    isPrivate: true,
  },
  {
    path: contentPath,
    navigation: [contentPageNav],
    Component: ListAllContent,
    exact: true,
    isPrivate: true,
  },
  {
    path: contentIdPath,
    navigation: [contentPageNav, contentIdPageNav],
    Component: ViewContentDetail,
    exact: true,
    isPrivate: true,
  },
];
